<tc-setup-grid
        #setupGrid
        [readOnly]="false"
        [colDefConfig]="colDefConfig"
        [setupGridComp]="this"
        [dataSource]="this"
        [headerActions]="headerActions"
        [cellEditingStart]="cellEditingStart">
</tc-setup-grid>
